export const objectToArray = obj => Object.keys(obj).map(key => obj[key]);



// WEBPACK FOOTER //
// ./src/helpers/data.js